import React from "react";

export default function Unauthorized() {
  return (
    <div style={{ padding: 20 }}>
      <h1>Unauthorized Access</h1>
      <p>You are not allowed to view this page.</p>
    </div>
  );
}
